import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

/** A page change cancels a delayed result; one-shot focus/search replacements on that page do not. */
export function useCurrentQuoteNavigation(): () => boolean {
  const { pathname } = useLocation();
  const page = useRef({ pathname, generation: 0 });
  const mounted = useRef(false);
  if (page.current.pathname !== pathname) {
    page.current = { pathname, generation: page.current.generation + 1 };
  }
  const generation = page.current.generation;
  useEffect(() => {
    mounted.current = true;
    return () => {
      mounted.current = false;
    };
  }, []);
  return () => mounted.current && page.current.generation === generation;
}
